import axios from 'axios';
import { delay } from 'redux-saga'
import {all, call, fork, put, takeEvery, select} from "redux-saga/effects";
import moment from 'moment';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import {BASE_URL_APIv5, BASE_HEADER, FILE_HEADER, BASE_URL_API} from "constants/ActionTypes";

import {
    REQ_DATA_NOTIF,
    GET_DATA_NOTIF,
    REQ_DATA_NOTIF_LOCK,
    GET_DATA_NOTIF_LOCK,
    REQ_DATA_NOTIF_DOCS,
    GET_DATA_NOTIF_DOCS,
} from 'constants/ActionTypes';

let companyIdGlobal = localStorage.getItem('companyId')

const getUserData = async () => {
    
    // return await axios.get(`${BASE_URL_APIv5}/alert-notification/list?start=0&length=10&orderby=id&asc=false&column=status&value=false&operator=AND&logic_operator==`, BASE_HEADER)
    //             .then((res) => res)
    //             .catch((error) => error.response)
    let today = moment(new Date()).format("YYYY-MM-DD")
    let payload = {
        paging : {start : 0, length: 10},
        orders : {columns:["wp_time"],ascending:false},
        columns : [
            {name:"wp_time","logic_operator":"range",value: today+" 00:00:00", value1: today+" 23:59:59","operator":"AND"},
            {name:"status","logic_operator":"=",value: "false","operator":"AND"}
        ]
    }

    let obj = JSON.stringify(payload)
    return await axios.post(`${BASE_URL_APIv5}/alert-notification/search`, obj, BASE_HEADER)
                .then((res) => res)
                .catch((error) => error.response)
}

const getNotifLock = async () => {
    // return await axios.get(`${BASE_URL_APIv5}/alert-notification/list?start=0&length=10&orderby=id&asc=false&column=status&value=false&operator=AND&logic_operator==`, BASE_HEADER)
    //             .then((res) => res)
    //             .catch((error) => error.response)
    let today = moment(new Date()).format("YYYY-MM-DD")
    let payload = {
        paging : {start : 0, length: 10},
        orders : {columns:["wp_time"],ascending:false},
        columns : [
            {name:"wp_time","logic_operator":"range",value: today+" 00:00:00", value1: today+" 23:59:59","operator":"AND"},
            {name:"status","logic_operator":"=",value: "false","operator":"AND"}
        ]
    }

    let obj = JSON.stringify(payload)
    return await axios.post(`${BASE_URL_APIv5}/alert-notification/search`, obj, BASE_HEADER)
                .then((res) => res)
                .catch((error) => error.response)
}

const getNotifDocs = async () => {
    let payload = {
        "start": 0,
        "length": 5,
        "notifType": "all",
        "companyId": companyIdGlobal,
        "notifName": "",
        "name": ""
    }

    let obj = JSON.stringify(payload)
    return await axios.post(`${BASE_URL_APIv5}/alert-notification-docs/search`, obj, BASE_HEADER)
                .then((res) => res)
                .catch((error) => error.response)
}


export function* setNotifData(){
    try {
        while (true) {
        
            const data = yield select(state => state.notif)
    
            if(data.statusNotif === true){
                break;
            }
    
            const result = yield call(getUserData)
            if(result.data.status === true){
                yield put({type: GET_DATA_NOTIF, payload: result.data.data});
            } else {
                NotificationManager.error(result.data.message, 'Error message')
            }
            yield call(delay, 60000)
            
        }
    
    } catch (error) {
        // console.log(error)
    }
}

export function* setNotifDataLock(){
    try {
        while (true) {
        
            const data = yield select(state => state.notif)
    
            if(data.statusNotif === true){
                break;
            }
    
            const result = yield call(getNotifLock)
            if(result.data.status === true){
                yield put({type: GET_DATA_NOTIF_LOCK, payload: result.data.data});
            } else {

            }
            yield call(delay, 60000)
            
        }
    
    } catch (error) {
        // console.log(error)
    }
}

export function* setNotifDataDocs(){
    try {
        while (true) {
            const data = yield select(state => state.notif)
            if(data.statusNotif === true){
                break;
            }
    
            const result = yield call(getNotifDocs)
            if(result.data.status === true){
                yield put({type: GET_DATA_NOTIF_DOCS, payload: result.data.data});
            } else {

            }

            yield call(delay, 60000)
        }
    } catch (error) {
        console.log(error)
    }
}


export function* reqNotifData(){
    yield takeEvery(REQ_DATA_NOTIF, setNotifData)
}

export function* reqNotifDataLock(){
    yield takeEvery(REQ_DATA_NOTIF_LOCK, setNotifDataLock)
}

export function* reqNotifDataDocs(){
    yield takeEvery(REQ_DATA_NOTIF_DOCS, setNotifDataDocs)
}

export default function* rootSaga() {
    yield all([
        fork(reqNotifData),
        fork(reqNotifDataLock),
        fork(reqNotifDataDocs)
    ]);
}


// WEBPACK FOOTER //
// ./sagas/Notif.js